import React from "react";

// Positional asset-value tiers (top 15 per position):
//  xfactor (1-5) = red Madden-style X-Factor hexagon, gold (6-10) = gold superstar,
//  silver (11-15) = silver superstar. Each carries a trade-tax premium.
const TIERS = {
  xfactor: { color: "#FF2D2D", label: "X-Factor" },
  gold: { color: "#FFC53D", label: "Superstar" },
  silver: { color: "#C7CDD6", label: "Star" },
};

export default function PlayerBadge({ badge, size = 16 }) {
  if (!badge) return null;
  const t = TIERS[badge.tier];
  if (!t) return null;
  const title = `${t.label} · ${badge.position} #${badge.pos_rank} · +${Math.round(badge.tax * 100)}% trade tax`;

  if (badge.tier === "xfactor") {
    return (
      <span title={title} data-testid={`badge-${badge.tier}`} className="inline-flex align-middle shrink-0" style={{ width: size, height: size }}>
        <svg viewBox="0 0 24 24" width={size} height={size}>
          <polygon points="12,1.5 21.5,7 21.5,17 12,22.5 2.5,17 2.5,7" fill="#1c0303" stroke={t.color} strokeWidth="2" />
          <path d="M8 8l8 8M16 8l-8 8" stroke={t.color} strokeWidth="2.4" strokeLinecap="round" />
        </svg>
      </span>
    );
  }

  const gid = `pb-${badge.tier}`;
  const topStop = badge.tier === "gold" ? "#FFE9A8" : "#F2F5FA";
  return (
    <span title={title} data-testid={`badge-${badge.tier}`} className="inline-flex align-middle shrink-0" style={{ width: size, height: size }}>
      <svg viewBox="0 0 24 24" width={size} height={size}>
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={topStop} />
            <stop offset="100%" stopColor={t.color} />
          </linearGradient>
        </defs>
        <path
          d="M12 2.2l2.95 6.0 6.6.97-4.78 4.66 1.13 6.57L12 17.85 6.08 20.96l1.13-6.57L2.43 9.17l6.6-.97z"
          fill={`url(#${gid})`}
          stroke={badge.tier === "gold" ? "#B8860B" : "#8A93A3"}
          strokeWidth="0.8"
        />
      </svg>
    </span>
  );
}
